import { render, staticRenderFns } from "./SingProduct.vue?vue&type=template&id=1b5554c8&scoped=true"
import script from "./SingProduct.vue?vue&type=script&lang=js"
export * from "./SingProduct.vue?vue&type=script&lang=js"
import style0 from "./SingProduct.vue?vue&type=style&index=0&id=1b5554c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5554c8",
  null
  
)

export default component.exports